<template>
    <div class="helpMain">
        <p class="titleMain">当前位置： <span>帮助中心</span></p>
        <div class="contextMain">
            <helpMenu :helpMeunId="helpMeunId" @getMeunId="getMeunId"></helpMenu>
            <div class="helpContext">
                <p class="contextTitle">{{ name }}</p>
                <div class="context">
                    <div  v-if="helpHtml != ''" v-html="helpHtml" ></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import helpMenu from './menu.vue'
export default{
    data(){
        return{
            helpMeunId: '',
            helpHtml: '',
            name: ''
        }
    },
    components:{
        helpMenu
    },
    methods: {
        getMeunId(val){
            this.helpMeunId = val
            let data = {
                id: val
            }
            this.helpInfo(data)
        },
        helpInfo(data){
            this.$store.dispatch('help/helpInfo',data)
                .then(res => {
                    if(res.data != null){
                        // this.helpHtml = res.data.intro
                        this.helpHtml = this.formatRichText(res.data.intro)
                        this.name = res.data.name
                    }else{
                        this.helpHtml = ''
                    }
                      
                   
                })
        },
        formatRichText (html, conWidth) {
            // 去掉img标签里的style、width、height属性
            let newContent= html.replace(/<img[^>]*>/gi,function(match,capture){
                match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
                match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
                match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
                return match;
            });
            
            // 去掉video标签里的style、width、height属性
            newContent= html.replace(/<video[^>]*>/gi,function(match,capture){
                match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
                match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
                match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
                return match;
            });
            
            // 修改所有style里的width属性为max-width:100%
            // 去掉所有style里的font-size属性
            newContent = newContent.replace(/style="[^"]+"/gi,function(match,capture){
                match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
                //match = match.replace(/font-size:[^;]+;/gi, '');
                //match = match.replace(/text-indent:[^;]+;/gi, '');
                return match;
            });
            // 去掉<br/>标签
            newContent = newContent.replace(/<br[^>]*\/>/gi, '');
            // img标签添加style属性：max-width:100%;height:auto
            newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:block;margin:0px auto;"');
            //newContent = newContent.replace(/\<img/gi, '<img style="width:'+ conWidth +'px;height:auto;display:block;margin:0px auto;"');
            //newContent = newContent.replace(/\<img/gi, '<img style="width:100%;height:auto;display:block;margin:0px auto;"');
            // video标签添加style属性：max-width:100%;height:auto
            newContent = newContent.replace(/\<video/gi, '<video style="max-width:100%;height:auto;display:block;margin:0px auto;"');
            return newContent;
        },
    },
    created(){
        this.helpMeunId = sessionStorage.getItem('helpMeunId')
        
        let data = {
            id: this.helpMeunId
        }
        this.helpInfo(data)
    
    }
}
</script>
<style scoped lang="scss">
.helpMain{
    width: 1200px;min-height: calc(100vh - 190px);
    padding: 10px 10px;
    margin: 45px auto;
    .titleMain{
        margin-top: -45px;
        font-size: 17px;
        color: #333;
        span{
            font-size: 16px;
            cursor: pointer;
            color: #666666;
        }
    }
    .contextMain{
        width: 100%;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        .helpContext{
            width: 930px;min-height: calc(100vh - 190px);
            background: #ffffff;
            .contextTitle{
                font-size: 18px;
                color: #333333;
                font-weight: 700;
                padding: 10px 25px;
            }
            .context{
                margin-top: 15px;
                padding: 10px 25px;
            }
        }
    }
}
</style>